module.exports = __webpack_public_path__ + "img/ring_advisory_with_heart.1912692.webp";